export var LabelPosition;
(function (LabelPosition) {
    LabelPosition[LabelPosition["TOP"] = 0] = "TOP";
    LabelPosition[LabelPosition["LEFT"] = 1] = "LEFT";
})(LabelPosition || (LabelPosition = {}));
export var InputType;
(function (InputType) {
    InputType["TEXT"] = "text";
    InputType["NUMBER"] = "number";
    InputType["PASSWORD"] = "password";
    InputType["TEL"] = "tel";
    InputType["EMAIL"] = "email";
})(InputType || (InputType = {}));
export var InputModeType;
(function (InputModeType) {
    InputModeType["TEL"] = "tel";
    InputModeType["TEXT"] = "text";
    InputModeType["URL"] = "url";
    InputModeType["EMAIL"] = "email";
    InputModeType["NUMERIC"] = "numeric";
    InputModeType["DECIMAL"] = "decimal";
    InputModeType["SEARCH"] = "search";
})(InputModeType || (InputModeType = {}));
//# sourceMappingURL=oh-input.types.js.map
